import React, { useEffect } from 'react';
import Modal from 'rsuite/Modal';
import SendMailForm from 'Components/Common/SendMail/SendMailForm';
import PropTypes from 'prop-types';

export default function SendMailModal(props) {
  const { isOpen, setOpen, codigoGeneracion, dteType  } = props;

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {}, []);

  return (
    <>
      <Modal size="md" open={isOpen} onClose={handleClose} backdrop="static">
        <Modal.Header>
          <Modal.Title>{'Enviar DTE por correo'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SendMailForm close={handleClose} codigoGeneracion={codigoGeneracion} dteType={dteType} />
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </>
  );
}

SendMailModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  data: PropTypes.object,
};
